exports = module.exports = require("../../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".van-swipe-item{float:left;height:100%}", "", {"version":3,"sources":["C:/Users/123/Desktop/孺教云应用/孺教网手机端/rjwmobile/node_modules/vant/lib/swipe-item/C:/Users/123/Desktop/孺教云应用/孺教网手机端/rjwmobile/node_modules/vant/lib/swipe-item/index.css"],"names":[],"mappings":"AAAA,gBAAgB,WAAW,WAAW,CAAC","file":"index.css","sourcesContent":[".van-swipe-item{float:left;height:100%}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--5-1!./node_modules/postcss-loader/lib??ref--5-2!./node_modules/vant/lib/swipe-item/index.css
// module id = fEcF
// module chunks = 1